// extracted by mini-css-extract-plugin
module.exports = {"gridcontainer":"VersePage_gridcontainer__13DMP","medium":"VersePage_medium__1t8hf","big":"VersePage_big__3K3e2","small":"VersePage_small__HmLk9"};